var map = {
	"./ic_avax_40.svg": 549,
	"./ic_bnb_40.svg": 550,
	"./ic_btc_40.svg": 401,
	"./ic_eth_40.svg": 402,
	"./ic_frax_40.svg": 551,
	"./ic_glp_40.svg": 553,
	"./ic_link_40.svg": 554,
	"./ic_mim_40.svg": 555,
	"./ic_uni_40.svg": 556,
	"./ic_usdc.e_40.svg": 557,
	"./ic_usdc_40.svg": 558,
	"./ic_usdt_40.svg": 559,
	"./ic_wavax_40.svg": 560,
	"./ic_wbnb_40.svg": 561,
	"./ic_weth_40.svg": 562
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 957;